// extracted by mini-css-extract-plugin
export default {"menu":"qrK79UJn9P0OqzZe5qtd","profilePic":"azKoNTUk7x7Yjea2e_yz"};